import { EntityVm } from "api/core/entity.vm";
import { IsString, IsOptional } from "class-validator";

export class PreparationAreaVm extends EntityVm {
    @IsString()
    warehouseId: string;

    @IsString()
    @IsOptional()
    preparedAreaId: string | null;
}
